import { en } from "./en.js";
import { ru } from "./ru.js";
import { sr } from "./sr.js";
import type { SiteText } from "./types.js";

/**
 * Тексты сайта по языкам: сербский (латиница), английский, русский (решение владельца 04.11.2026: везде три языка).
 * Новый язык: файл той же формы (`SiteText`) и строка здесь; переключатель в `SiteLayout` и выбор языка
 * в `useSiteLang` берут список из `siteLangs`. Порядок здесь задаёт порядок в переключателе.
 */
export const siteText = { sr, en, ru } satisfies Record<string, SiteText>;
export type SiteLang = keyof typeof siteText;
export const siteLangs = Object.keys(siteText) as SiteLang[];
export type { SiteText } from "./types.js";
